import { RpcErrorCode } from '../../errors/rpc.js';
export const getBalance = async (client, { baseUrl }, { address }) => {
    const apiUrl = `${baseUrl}/address/${address}?details=basic`;
    const response = (await client.request({
        url: apiUrl,
        fetchOptions: {
            method: 'GET',
        },
    }));
    if (response.error) {
        return {
            error: { code: RpcErrorCode.MISC_ERROR, message: response.error },
        };
    }
    return {
        result: BigInt(response.balance),
    };
};
//# sourceMappingURL=getBalance.js.map